import { Controller } from '@hotwired/stimulus'

export default class NewUboSignatureController extends Controller {
  static targets = [
    'button',
    'submitButton',
    'form',
  ]

  static values = {
    uboDeclarationId: String,
  }

  formTargetConnected() {
    this.connectToChannel();
  }

  connectToChannel() {
    App.cable.subscriptions.create({
      channel: 'UboSignatureChannel',
      ubo_declaration_id: this.uboDeclarationIdValue,
    }, {
      received(data) {
        window.location.href = data.url;
      },
    });
  }

  sign(event) {
    this.buttonTarget.textContent = event.params.loadingText;
    this.buttonTarget.classList.add('disabled');
    this.submitButtonTarget.disabled = true;

    return true;
  }

  disableButton() {
    this.buttonTarget.classList.add('disabled');
  }
}
